import { gql } from 'apollo-client-ppc';
import { commonCommerceAddress } from '@css-xp/ppc-common/src/fragments/fragments';

export const fetchInvoiceGroupDetails = gql`
  ${commonCommerceAddress}
  query fetchInvoiceGroupDetails($id: ID!, $txaId: ID) {
    invoiceGroup(id: $id, txaId: $txaId) {
      id
      name
      currency
      transactionAccountId
      invoiceGroupNumber
      termPaymentStatus {
        status
      }
      shipToParty {
        ...commerceAddressFields
        shipToPriceEligibility
      }
      isActive
      purchaseOrder {
        number
        oneTimeUse
      }
    }
  }
`;
